var exports = {
  "vK": "x31de4314--5754fd--banner",
  "Qs": "x31de4314--5754fd--content",
  "wx": "x31de4314--5754fd--header",
  "H8": "x31de4314--5754fd--decoration",
  "wm": "x31de4314--5754fd--logo",
  "sT": "x31de4314--5754fd--promo",
  "Lr": "x31de4314--5754fd--promo-field",
  "Ms": "x31de4314--5754fd--promo-code",
  "wA": "x31de4314--5754fd--promo-icon",
  "rg": "x31de4314--5754fd--promo-caption",
};

module.exports = exports;
